import { useCallback, useRef } from "react";
import { toast } from "react-toastify";
import { useNotificationCreateMutation } from "../hooks/fileUploadMutation";
// * hooks
import { useAuth } from "../services/auth";

const NotificationScreen = () => {
  const { authData } = useAuth();

  const textRef = useRef<HTMLInputElement>(null);
  const onSuccessCreate = useCallback(() => {
    if (textRef.current) {
      textRef.current.value = "";
    }
    toast.success("Notification success");
  }, []);
  const { mutate: createMutate, isLoading: createLoading } =
    useNotificationCreateMutation(authData?.token ?? "", onSuccessCreate);

  return (
    <div className="py-[38px] px-[28px] h-full bg-backgroundSecondary">
      <div className="px-[29px] h-[54px] w-2/3 rounded-md shadow-md bg-backgroundTertiary flex flex-col justify-center text-bg01 font-semibold">
        Send Notification
      </div>
      <div className="mt-[32px] px-[29px] py-[27px] w-2/3 rounded-md shadow-md bg-backgroundTertiary">
        <div className="text-bg01 font-semibold">
          <input
            ref={textRef}
            placeholder="Enter Notification text"
            className="mt-2 px-[15px] py-[8px] w-1/2 rounded-md border border-primary bg-backgroundPrimary text-sm focus:outline-none"
          />
        </div>
        <div className="mt-[40px] flex flex-row">
          <div
            onClick={() => {
              const notificationText = textRef.current?.value ?? "";
              if (createLoading || notificationText === "") {
              } else {
                createMutate(notificationText);
              }
            }}
            className="w-[120px] h-[44px] rounded bg-bg01 text-backgroundTertiary flex flex-col justify-center items-center cursor-pointer hover:opacity-80"
          >
            Add
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationScreen;
